import _createForOfIteratorHelper from "/opt/github/_work/frontend-website-cms/frontend-website-cms/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import $ from "cash-dom";
import Swiper from "swiper";
import ScrollOut from "scroll-out";
import "swiper/css/swiper.min.css";

function HeaderDropdown(element) {
  this.element = element;
  this.mainNavigation = this.element.find(".header-content");
  this.mainNavigationItems = this.mainNavigation.find(".has-dropdown");
  this.dropdownList = this.element.find(".header-dropdown-container");
  this.dropdownWrappers = this.dropdownList.find(".header-dropdown");
  this.dropdownItems = this.dropdownList.find(".header-dropdown-content");
  this.dropdownBg = this.element.find(".header-background");
  this.mq = this.checkMq();
  this.setupHeader();
}

HeaderDropdown.prototype.checkMq = function () {
  // check screen size
  var self = this; // return window.getComputedStyle(self.element.get(0), '::before').getPropertyValue('content').replace(/'/g, "").replace(/"/g, "").split(', ');

  this.dropdownBg.css({
    height: this.mainNavigation.innerHeight()
  });
};

HeaderDropdown.prototype.setupHeader = function () {
  var self = this;
  this.mainNavigationItems.on("mouseenter", function (event) {
    self.showDropdown($(this));
  }).on("mouseleave", function () {
    setTimeout(function () {
      if (self.mainNavigation.find(".has-dropdown:hover").length === 0 && self.element.find(".header-dropdown-container:hover").length === 0) {
        self.hideDropdown();
      }
    }, 50);
  });
  this.dropdownList.on("mouseleave", function () {
    setTimeout(function () {
      self.mainNavigation.find(".has-dropdown:hover").length === 0 && self.element.find(".header-dropdown-container:hover").length === 0 && self.hideDropdown();
    }, 50);
  });
  this.element.on("click", ".nav-trigger", function (event) {
    event.preventDefault();
    self.element.toggleClass("nav-open");
  });
  this.dropdownBg.css({
    height: this.mainNavigation.innerHeight()
  });
};

HeaderDropdown.prototype.showDropdown = function (item) {
  var self = this;
  var selectedDropdown = this.dropdownList.find("#".concat(item.data("content")));
  var selectedDropdownHeight = selectedDropdown.innerHeight() + this.mainNavigation.innerHeight();
  var selectedDropdownWidth = selectedDropdown.children(".header-dropdown-content").innerWidth();
  var selectedDropdownLeft = item.offset().left + item.innerWidth() / 2 - selectedDropdownWidth / 2; // update dropdown position and size
  // console.log(parseInt(selectedDropdownHeight), selectedDropdownWidth, parseInt(selectedDropdownLeft))

  this.updateDropdown(selectedDropdown, parseInt(selectedDropdownHeight), selectedDropdownWidth, parseInt(selectedDropdownLeft)); // add active class to the proper dropdown item

  this.element.find(".active").removeClass("active");
  selectedDropdown.addClass("active").removeClass("move-left move-right");
  selectedDropdown.prevAll().addClass("move-left");
  selectedDropdown.nextAll().addClass("move-right");
  item.addClass("active"); // show the dropdown wrapper if not visible yet

  if (!this.element.hasClass("is-dropdown-visible")) {
    setTimeout(function () {
      self.element.addClass("is-dropdown-visible");
    }, 10);
  }
};

HeaderDropdown.prototype.updateDropdown = function (dropdownItem, height, width, left) {
  this.dropdownBg.css({
    height: height
  });
};

HeaderDropdown.prototype.hideDropdown = function () {
  this.element.removeClass("is-dropdown-visible").find(".active").removeClass("active");
  this.element.find(".move-left").removeClass("move-left");
  this.element.find(".move-right").removeClass("move-right");
  this.dropdownBg.css({
    height: this.mainNavigation.innerHeight()
  });
};

HeaderDropdown.prototype.resetDropdown = function () {
  var self = this;
  this.mq = this.checkMq();

  if (!$(".header-dropdown.active")) {
    this.dropdownBg.css({
      height: this.mainNavigation.innerHeight()
    });
  } else {
    this.dropdownBg.css({
      height: $(".header-dropdown.active").innerHeight() + this.mainNavigation.innerHeight()
    });
  }
};

function sideBarEnter(item) {
  $(".moremenu--item").removeClass("is-active");
  $(".moremenu--item.".concat(item)).addClass("is-active");
  clearTimeout();
  $(".more-menu-site-logo").addClass("fade");
  setTimeout(function () {
    $(".close-more-slide").removeClass("fade");
  }, 400);
  $(".more-content").addClass("slide");
  $(".close-more-slide").on("click touch", function (e) {
    e.preventDefault();
    $(".more-menu-link").removeClass("is-active");
    $(this).addClass("fade");
    clearTimeout();
    setTimeout(function () {
      $(".more-menu-site-logo").removeClass("fade");
      $(".moremenu--item.is-active").removeClass("is-active");
    }, 400);
    $(".more-content").removeClass("slide");
  });
}
/* eslint-disable */


export default function initHeader() {
  ScrollOut({
    targets: ".js-header"
  });
  var HeaderDropdowns = [];

  if ($(".header").length > 0) {
    $(".header").each(function () {
      HeaderDropdowns.push(new HeaderDropdown($(this)));
    });
    updateDropdownPosition(HeaderDropdowns);
    $(window).on("resize", function () {
      updateDropdownPosition(HeaderDropdowns);
    });

    function updateDropdownPosition(HeaderDropdowns) {
      HeaderDropdowns.forEach(function (el) {
        el.resetDropdown();
      });
    }

    $(".datasub__menu").on("click", function () {
      var menu = $(this).attr("href");
      $(this).addClass("current");
      $(".datasub__menu, .datasub__group").not($(this)).removeClass("current");
      $(menu).addClass("current");
      setTimeout(updateDropdownPosition, 15);
      return false;
    });
  }

  var headerSwiper = new Swiper(".js-headerswiper", {
    slidesPerView: "auto",
    loop: false,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });
  $(".js-submenuTrigger").on("click", function () {
    $(".subheader").toggleClass("is-dropdown-visible");
  }); // Dropdown menu

  if ($(".subheader__dropdownMenu").length > 0) {
    $(".js-dropdownMenuNext").on("click", function (e) {
      var currentScroll = $(".subheader__dropdownMenu")[0].scrollLeft;
      scrollDropdownMenu(300);
      e.preventDefault();
    });
    $(".js-dropdownMenuPrev").on("click", function (e) {
      var currentScroll = $(".subheader__dropdownMenu")[0].scrollLeft;
      scrollDropdownMenu(-300);
      e.preventDefault();
    });

    function scrollPositionCheck() {
      var scrollLeft = $(".subheader__dropdownMenu")[0].scrollLeft;
      var scrollLeftMax = $(".subheader__dropdownMenu")[0].scrollLeftMax;

      if (scrollLeft === 0) {
        $(".js-dropdownMenuPrev").addClass("hidden");
      } else {
        $(".js-dropdownMenuPrev").removeClass("hidden");
      }

      if (scrollLeft >= scrollLeftMax) {
        $(".js-dropdownMenuNext").addClass("hidden");
      } else {
        $(".js-dropdownMenuNext").removeClass("hidden");
      }
    }

    scrollPositionCheck();

    function scrollDropdownMenu(amount) {
      var currentScroll = $(".subheader__dropdownMenu")[0].scrollLeft;
      $(".subheader__dropdownMenu")[0].scrollLeft = currentScroll + amount;
      scrollPositionCheck();
    }

    $(".subheader__dropdownMenu")[0].addEventListener("scroll", function () {
      scrollPositionCheck();
    });
  } // Subheader menu


  if ($(".subheader__menu").length > 0) {
    $(".js-subheaderMenuNext").on("click", function (e) {
      var currentScroll = $(".subheader__menu")[0].scrollLeft;
      scrollSubMenu(150);
      e.preventDefault();
    });
    $(".js-subheaderMenuPrev").on("click", function (e) {
      var currentScroll = $(".subheader__menu")[0].scrollLeft;
      scrollSubMenu(-150);
      e.preventDefault();
    });

    function scrollSubmenuPositionCheck() {
      var scrollLeft = $(".subheader__menu")[0].scrollLeft;
      var scrollLeftMax = $(".subheader__menu")[0].scrollLeftMax;

      if (scrollLeft === 0) {
        $(".js-subheaderMenuPrev").addClass("hidden");
      } else {
        $(".js-subheaderMenuPrev").removeClass("hidden");
      }

      if (scrollLeft >= scrollLeftMax) {
        $(".js-subheaderMenuNext").addClass("hidden");
      } else {
        $(".js-subheaderMenuNext").removeClass("hidden");
      }
    }

    scrollSubmenuPositionCheck();

    function scrollSubMenu(amount) {
      var currentScroll = $(".subheader__menu")[0].scrollLeft;
      $(".subheader__menu")[0].scrollLeft = currentScroll + amount;
      scrollSubmenuPositionCheck();
    }

    $(".subheader__menu")[0].addEventListener("scroll", function () {
      scrollSubmenuPositionCheck();
    });
  } // Bigpicture tab layouts


  if ($("#bigpicture").length > 0) {
    var tabContainers = $(".bigpicture__tabsContainer");

    var _iterator = _createForOfIteratorHelper(tabContainers),
        _step;

    try {
      var _loop = function _loop() {
        var container = _step.value;
        $(container).parent().find(".js-tabMenuNext").on("click", function (e) {
          var currentScroll = $(container)[0].scrollLeft;
          scrollSubMenu(150);
          e.preventDefault();
          return false;
        });
        $(container).parent().find(".js-tabMenuPrev").on("click", function (e) {
          var currentScroll = $(container)[0].scrollLeft;
          scrollSubMenu(-150);
          e.preventDefault();
          return false;
        });

        function scrollSubmenuPositionCheck(container) {
          var scrollLeft = container.scrollLeft;
          var scrollLeftMax = container.scrollLeftMax;

          if (scrollLeft === 0) {
            $(container).parent().find(".js-tabMenuPrev").addClass("hidden");
          } else {
            $(container).parent().find(".js-tabMenuPrev").removeClass("hidden");
          }

          if (scrollLeft >= scrollLeftMax || container.scrollWidth <= container.clientWidth) {
            $(container).parent().find(".js-tabMenuNext").addClass("hidden");
          } else {
            $(container).parent().find(".js-tabMenuNext").removeClass("hidden");
          }
        }

        scrollSubmenuPositionCheck(container);

        function scrollSubMenu(amount) {
          var currentScroll = container.scrollLeft;
          container.scrollLeft = currentScroll + amount;
          scrollSubmenuPositionCheck(container);
        }

        $(container)[0].addEventListener("scroll", function () {
          scrollSubmenuPositionCheck(container);
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } // hide subheader


  window.addEventListener("scroll", function () {
    $(".subheader").removeClass("is-dropdown-visible");
  });
  $(document).on("mouseup", function (e) {
    var $el = $(".subheader");

    if (!$el.is(e.target) && $el.has(e.target).length === 0) {
      $el.removeClass("is-dropdown-visible");
    }
  });

  if ($(".subheader__menuLink.is-active").length) {
    // submenu offset minus the width of the "State of the Union" image and menu
    var offset = $(".subheader__menuLink.is-active")[0].offsetLeft - 250;
    $(".subheader__menu")[0].scrollLeft = offset;
  }

  $(".search-icon-mobile").on("click", function (e) {
    e.preventDefault();

    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(".search__form").addClass("hidden").removeClass("bottom-0 right-6");
      $(".search__form").css({
        position: "relative",
        transform: "translateY(0%)"
      });
      $("#search-toggle-mobile").removeClass("hidden");
      $("#search-close-mobile").addClass("hidden");
    } else {
      $(this).addClass("active");
      $(".search__form").css({
        position: "absolute",
        transform: "translateY(100%)"
      });
      $(".search__form").removeClass("hidden").addClass("bottom-0 right-6");
      $("#search-toggle-mobile").addClass("hidden");
      $("#search-close-mobile").removeClass("hidden");
    }
  });
  $(".more-menu-link").on("click touch", function (e) {
    $(this).addClass("is-active");
    $(".more-menu").addClass("is-active");
    $("body").addClass("is-menuopen");
    e.preventDefault();
  });
  $(".close-more-menu").on("click touch", function (e) {
    $(".more-menu").removeClass("is-active");
    $(".more-menu-link").removeClass("is-active");
    $("body").removeClass("is-menuopen");
    e.preventDefault();
  });
  $(".moremenu--sidebar-item").on("click touch", function (e) {
    e.preventDefault();
    $(".moremenu--sidebar-item").removeClass("is-active");
    $(this).addClass("is-active");
    sideBarEnter($(this).attr("data-content"));
  });
}
/* eslint-enable */